import React from "react";
import { TextFieldProps } from "@material-ui/core";
import { HiddenStyledTextField } from "./HiddenTextField.styled";

export const HiddenTextField: React.FC<TextFieldProps> = (props) => {
    return <HiddenStyledTextField {...props} />;
};
